import { useState } from 'react'
import { translate, type Lang } from './i18n'
import type { UncoveredHotspot } from './api'

/** Cuántos se muestran antes de «ver todos»: los de más riesgo son los que deciden. */
const FIRST = 6

/**
 * Los hotspots que un plan parcial deja sin ninguna visita, por riesgo.
 *
 * Aceptar un parcial se firmaba a ciegas: la casilla decía «hay hotspots sin ninguna visita» y no
 * cuáles (hallazgo H-37 de la prueba integral). No es lo mismo dejar fuera el de rango 40 que el 2.
 */
export function UncoveredList({ lang, items }: { lang: Lang; items: UncoveredHotspot[] | undefined }) {
  const [todos, setTodos] = useState(false)
  if (!items || items.length === 0) return null
  const shown = todos ? items : items.slice(0, FIRST)
  return (
    <div className="meta" style={{ marginBottom: 6 }}>
      <strong>{translate(lang, 'uncovered.title', [items.length])}</strong>
      <ul style={{ margin: '4px 0 0 0', paddingLeft: 18 }}>
        {shown.map((h) => (
          <li key={`${h.rank}-${h.label}`}>
            {translate(lang, 'uncovered.item', [h.rank, h.label, h.division, h.riskScore.toFixed(1)])}
            {h.reason ? ` · ${h.reason}` : ''}
          </li>
        ))}
      </ul>
      {items.length > FIRST && (
        <button onClick={() => setTodos(!todos)}>
          {translate(lang, todos ? 'uncovered.fewer' : 'uncovered.all', [items.length - FIRST])}
        </button>
      )}
    </div>
  )
}
